export default __webpack_public_path__ + "static/media/embedded product.01f45fd5.png";